import React from 'react';
import { Lpqv as LpqvIcon } from '@profitfy/pakkun-icons';
import { useTheme } from 'styled-components/macro';
import { useParams } from 'react-router-dom';

import { EHeadingSize, EHeadingWeight } from '@domain/enums/components/EHeading';
import { IParams } from '@domain/interfaces/IParams';

import lpqvAuthService from '@services/pages/dashboard/integrationCenter/storeProvider/lpqv/lpqvAuth';

import ComponentError from '@components/common/core/Utils/ComponentError';
import CredentialOption from './CredentialOption';
import GatewayOption from './GatewayOption';
import EnableIntegration from './EnableIntegration';
import SyncOption from './SyncOption';
import SkeletonLoading from '../SkeletonLoading';

import * as S from './styles';

const LPQVConfig: React.FC = () => {
  const theme: any = useTheme();
  const { storeAliasId } = useParams<IParams>();

  const {
    lpqvCredential,
    isLoading,
    isValidating,
    mutate,
    error,
  } = lpqvAuthService.getLpqvCredential({ storeAliasId });

  const [selectedTab, setSelectedTab] = React.useState<number>(0);

  const onChangeTab = React.useCallback(index => setSelectedTab(index), []);

  if (isLoading || isValidating) {
    return <SkeletonLoading />;
  }

  if (error && !isLoading) {
    return <ComponentError mutate={mutate} />;
  }

  if (!lpqvCredential.is_active) {
    return <EnableIntegration lpqvCredential={lpqvCredential} mutate={mutate} />;
  }

  return (
    <S.ContentWrapper>
      <S.Header>
        <LpqvIcon size={52} color={theme.colors.gray[2]} />
        <S.Heading type={EHeadingSize.H4} fontWeight={EHeadingWeight.REGULAR}>
          Integração com LPQV
        </S.Heading>
      </S.Header>

      <S.Tab defaultTab={selectedTab} onChangeTab={onChangeTab}>
        <S.Option>Geral</S.Option>
        <S.Option>Sincronização</S.Option>
        <S.Option>Gateway</S.Option>
      </S.Tab>

      {selectedTab === 0 && <CredentialOption lpqvCredential={lpqvCredential} mutate={mutate} />}

      {selectedTab === 1 && <SyncOption />}

      {selectedTab === 2 && <GatewayOption />}
    </S.ContentWrapper>
  );
};

export default LPQVConfig;
